<template>
  <div class="breadcrumbs p-3">
    <a href="/">Αρχική</a> / <strong>Προσωπικά Στοιχεία</strong>
  </div>
  <div class="login-wrapper">
    <div class="card shadow-none px-xl-5">
      <h3>Προσωπικά Στοιχεία</h3>

      <form @submit.prevent="saveProfile">
        <div class="field">
          <label>Όνομα</label>
          <input v-model="profile.name" type="text" required />
        </div>

        <div class="field">
          <label>Επώνυμο</label>
          <input v-model="profile.surname" type="text" required />
        </div>

        <div class="field">
          <label>Τηλέφωνο</label>
          <input v-model="profile.mobile" type="tel" required />
        </div>

        <div class="field">
          <label>Email</label>
          <input v-model="profile.email" type="email" disabled />
        </div>

        <div class="btn-wrap">
          <button class="btn btn-primary" type="submit">Αποθήκευση</button>
        </div>
      </form>
      <div class="delete-account-wrap">
        <a class="delete-account" @click="showDeleteModal = true">
          Διαγράψτε το λογαριασμό σας
        </a>
      </div>

      <Teleport to ='body'>
        <div v-if="showDeleteModal" class="modal fade show d-block"  tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="deleteAccountModalLabel">
                  Επιβεβαίωση Διαγραφής
                </h5>
                <div class="btn-close-wrap">
                  <button type="button" class="btn-close" @click="showDeleteModal = false"  aria-label="Close"></button>
                </div>
              </div>

              <div class="modal-body">
                Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας;
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="showDeleteModal = false">
                  Ακύρωση
                </button>
                <button type="button" class="btn btn-danger" @click="confirmDelete">
                  Διαγραφή
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </Teleport>
      <div
        v-if="showDeleteModal"
        class="modal-backdrop fade show"
        @click="showDeleteModal = false"
      ></div>
    </div>
  </div>
</template>




<script setup>
import { reactive, watch, onMounted, ref} from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { updateProfile, fetchUserInfo, deleteAccount } from '@/services/user';
import { useRouter } from 'vue-router';


const toast = useToast();
const store = useStore();
const router = useRouter();
const showDeleteModal = ref(false);


const profile = reactive({
  name: '',
  surname: '',
  mobile: '',
  email: '',
});

// Watch the store.userInfo in case it changes
watch(
  () => store.state.userInfo,
  (user) => {
    console.log('Watcher triggered, store.userInfo:', user);
    if (user) {
      profile.name = user.name || '';
      profile.surname = user.surname || '';
      profile.mobile = user.mobile || '';
      profile.email = user.email || '';
    }
  },
  { immediate: true }
);

// On mount, fetch user data and store it
onMounted(async () => {
  const response = await fetchUserInfo();
  if (response.data?.info) {
    store.commit('setUserInfo', response.data.info);
  }
});

// Save profile function
async function saveProfile() {
  const payload = {
    name: profile.name,
    surname: profile.surname,
    mobile: profile.mobile,
  };

  const res = await updateProfile(payload);

  if (res.success) {
    toast.success(res.message);
    window.location.reload();
  } else {
    toast.error(res.message);
  }
}



async function confirmDelete() {
  // Example call
  const res = await deleteAccount();

  if (res.success) {
    toast.success(res.message);
    setTimeout(() => {
      window.location.href = '/';
    }, 2000);
  }


  showDeleteModal.value = false;
}

</script>



<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  max-width: 400px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

label {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

input {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.btn-wrap {
  text-align: center;
}

button {
  margin-top: 10px;
  padding: 10px;
  border-radius: 6px;
  border: none;
  color: #fff;
  cursor: pointer;
  width: 100%;
  max-width: 200px;
  font-weight: 700;
}

.delete-account-wrap{
  text-align: center;
  margin-top:30px;
  cursor: pointer;
}

.delete-account{
  color:var(--primary-color);
  text-decoration: underline;
}

.btn-close-wrap .btn-close{
  position: relative; 
  right: 5px; 
}

@media (max-width: 576px) {
  .modal-footer .btn{    
    max-width:150px;
  }

  .btn-close-wrap{
    text-align: right;
  }

 
}


</style>
